/**
 * @fileoverview Vuex module for maker-checker approval workflow.
 *
 * @module store/modules/makerchecker
 *
 * Combines actions, getters, mutations, and state for the maker-checker
 * pattern, which enforces a two-person review process for bot changes.
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { MakerCheckerState } from "./types";
import { RootState } from "@/store/types";

const makerChecker: Module<MakerCheckerState, RootState> = {
  // namespaced: true,
  getters,
  state,
  actions,
  mutations,
};

export default makerChecker;
